import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje, MensajeSiNo } from '../../mensajes';

import { Dimmer } from "../../spinner";

import { validaSoloNumero, formatMoneda, validaMonto, formatoMonto } from '../../../util/varios';
import TablaPagosComercio from '../actividadEconomica/tablaPagosComercios';
import TablaFacturasContribuyente from '../actividadEconomica/tablaFacturasContribuyentes';
import TablaHistoricoRetenciones from '../actividadEconomica/tablaHistoricoRetenciones'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import TablaVinculo from './tablaVinculo';

export const ModalVincular = (props) => {

    /*  variables de estados */

    let op = require('../../../../src/modulos/datos');

    const btnCancela = useRef();
    const btnAcepta = useRef();
    const [mostrar, setMostrar] = useState(false);
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mostrar1, setMostrar1] = useState(false);
    const [titulo2, setTitulo2] = useState();
    const [msg2, setMsg2] = useState();
    const [contar1, setContar1] = useState(0);
    const [activate, setActivate] = useState(false);
    const txtCodigoCiu = useRef();
    const txtIdactividad = useRef();
    const txtAlicuota = useRef();
    const txtDescripcionActi = useRef();
    const txtAnios = useRef();
    const txtMinimo = useRef();
    const txtActualizada = useRef();
    const txtCodActividad = useRef();
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [tabIndex, setTabIndex] = useState(0);
    const [visible, setVisible] = useState(false);
    const [idUsuario, setIdUsuario] = useState();
    const [declaWeb, setDeclaWeb] = useState();
    const txtIdComercio = useRef();
    const txtRitm = useRef();
    const txtNumPatente = useRef();
    const txtDenominacionCome = useRef();
    const txtDireccionContri = useRef();
    const txtEmailContri = useRef();
    const txtCedula = useRef();
    const cmbStatus = useRef();
    const txtObserStatus = useRef();



    const handleCloseSi = () => {
        setMostrar1(false);
    };

    const handleCloseNo = () => {
        setMostrar1(false);
    };


    const handleCloseMensa = () => {
        setMostrar(false);
    }


    const handleInputChange = (event) => {
        if (event.which === 13) {
            if (event.target.id === 'inputCodigo') {
                txtCodActividad.current.focus();
            } else if (event.target.id === 'inputCodigoActi') {
                txtCodigoCiu.current.focus();
            } else if (event.target.id === 'inputCodigoCiu') {
                txtAnios.current.focus();
            } else if (event.target.id === 'inputAnio') {
                txtDescripcionActi.current.focus();
            } else if (event.target.id === 'inputDescripcion') {
                txtAlicuota.current.focus();
            } else if (event.target.id === 'inputActualizada') {
                btnAcepta.current.focus();
            }
        } else if (typeof (event.which) === 'undefined') {
            return false;
        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;//alert(e.which);
    };

    const handleInputMontoChange = (event) => {
        //setActiveIndex(1);
        validaMonto(event);
        if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
            event.target.value = '0,00'
        }
        if (event.which === 13 || typeof (event.which) === 'undefined') {

            /* if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
                event.target.value = '0,00'
            } */
            event.target.value = (formatoMonto(event.target.value));
            let char1 = event.target.value.substring(0, 1);
            let char2 = event.target.value.substring(1, 2);
            if (char1 === '0' && char2 !== ',') {
                event.target.value = event.target.value.substring(1, event.target.value.legth);
            }
            if (event.which === 13) {
                if (event.target.id === 'inputAlicuota') {
                    txtMinimo.current.focus();
                } else if (event.target.id === 'inputMinimo') {
                    txtActualizada.current.focus();
                }
            }

        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;//alert(e.which);
    };

    const handleInputNumChange = (event) => {
        //setActiveIndex(1);
        validaSoloNumero(event);
        if (event.which === 13 || typeof (event.which) === 'undefined') {

            if (event.which === 13) {
                if (event.target.id === 'inputAnio') {
                    txtDescripcionActi.current.focus();
                }
            }

        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;//alert(e.which);
    };


    const onChangeValidar = () => {

        var sigue = true;

        if (txtCodActividad.current.value.trim() === '') {
            setTitulo('Error');
            setMsg('Debe suministrar el codigo .');
            setMostrar(true);
            txtCodActividad.current.focus();
            sigue = false;

        } else if (txtCodigoCiu.current.value.trim() === '') {
            setTitulo('Error');
            setMsg('Debe suministrar el codigo Ciu.');
            setMostrar(true);
            txtCodigoCiu.current.focus();
            sigue = false;

        } else if (txtAnios.current.value.trim() === '') {
            setTitulo('Error');
            setMsg('Debe suministrar el Año.');
            setMostrar(true);
            txtAnios.current.focus();
            sigue = false;

        } else if (txtDescripcionActi.current.value.trim() === '0') {
            setTitulo('Error');
            setMsg('Debe suministrar la Descripcion.');
            setMostrar(true);
            txtDescripcionActi.current.focus();
            sigue = false;

        } else if (txtAlicuota.current.value.trim() === '0') {
            setTitulo('Error');
            setMsg('Debe suministrar el Alicuota.');
            setMostrar(true);
            txtAlicuota.current.focus();
            sigue = false;

        } else if (txtMinimo.current.value.trim() === '0') {
            setTitulo('Error');
            setMsg('Debe suministrar el Minimo.');
            setMostrar(true);
            txtMinimo.current.focus();
            sigue = false;

        } else if (txtActualizada.current.value.trim() === '0') {
            setTitulo('Error');
            setMsg('Debe suministrar la Actualizada.');
            setMostrar(true);
            txtActualizada.current.focus();
            sigue = false;

        }

        if (sigue) {

            var txtCodigo = '';
            var txtCodigoAct = '';
            var txtCodCiu = '';
            var txtAnio = '';
            var txtDescripcion = '';
            var txtalicuota = '';
            var txtminimo = '';
            var txtactualizada = '';


            txtCodigo = txtIdactividad.current.value;
            txtCodigoAct = txtCodActividad.current.value;
            txtCodCiu = txtCodigoCiu.current.value;
            txtAnio = txtAnios.current.value;
            txtDescripcion = txtDescripcionActi.current.value;
            txtalicuota = txtAlicuota.current.value;
            txtminimo = txtMinimo.current.value;
            txtactualizada = txtActualizada.current.checked;

            props.onHideAcepta(txtCodigo, txtCodigoAct, txtCodCiu, txtAnio, txtDescripcion, txtalicuota,
                txtminimo, txtactualizada);
        }

    };

    const imprimirRelacionPago = ()/*  => (event) */ => {
        /* event.preventDefault(); */

        var reporte = 'Planillacontricomercio';
        var idcomercio = props.comercio.idcomercio;
        /* /siap?reporte=Planillacontricomercio&id=79&tipo=(2,34,69) */
      //  window.open(op.reportes + "reporte=" + reporte + "&id=" + idcomercio + "&tipo=(2,34,69)", "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
      window.open(op.reportes + "/inmueblesurbanos?" + "reporte=" + reporte + "&id=" + idcomercio +  "&tipo=(2,34,69)", "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
   

    }

    const imprimirDeudaGeneral = ()/*  => (event) */ => {

        var reporte = 'Hac_DeudaGeneral';

        window.open(op.reportes + "reporte=" + reporte + "&rif=" + props.comercio.rif.trim() + "&cedula=" + props.comercio.reprelegal.trim(), "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");

    }

    const salir = () => {

        props.onHideCancela();
    }
    const handlerClickTab = (index, lastIndex, event) => {
        //alert("Tab seleccionado: " + index + " .\ Tab anterior seleccionado: " + lastIndex);
        if (operacion === 1 && (index === 2 || index === 3)) {
            setTabIndex(0);
        } else {
            setTabIndex(index);
        }
    }
    return (
        <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => {
                setDeshabilitado(props.deshabilitado);
                setOperacion(props.operacion);

                
                setIdUsuario(props.idusuario);
                setDeclaWeb(props.declaweb);
                setTabIndex(0);
                setContar1(0);
            }}

        >
            <Modal.Header style={{ backgroundColor: "rgb(106, 115, 123)" }}>
                <Modal.Title style={{ color: "#fff" }}>Vincular Uso del Inmueble</Modal.Title>
                <button ref={btnCancela} className="btn" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={props.onHideCancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body style={{ backgroundColor: "#0e5694", color: "#ffffff" }}>
                <Mensaje titulo={titulo} mensaje={msg}
                    show={mostrar}
                    onHide={handleCloseMensa} />
                <MensajeSiNo titulo={titulo2} mensaje={msg2}
                    show={mostrar1}
                    onHideSi={handleCloseSi} onHideNo={handleCloseNo} />
              <Dimmer active={activate} inverted>
       
      </Dimmer>

                <TablaVinculo/>

                

            </Modal.Body>
            <Modal.Footer style={{ backgroundColor: "rgb(106, 115, 123)" }}>
            <button  className="btn btn-primary col-md-2"><i className="fas fa-print">  Aceptar</i></button>
                <button  onClick={props.onHideCancelar} className="btn btn-danger col-md-2"><i className="fas fa-window-close"> Cancelar</i></button>
               
            </Modal.Footer>
        </Modal>
    );
}

{/*                     <div className="col-md-12" style={{marginTop:"10px"}}>

        <div className="form-check form-check-inline">
            <label htmlFor="inputRitm">Mostrar Deuda en:</label>
        </div>
        <div className="form-check form-check-inline">
            <input className="form-check-input" type="radio" name="radioDeclara" value="1" id="radioSi" />
            <label className="form-check-label" htmlFor="inlineRadio2">Bolivares</label>
        </div>
        <div className="form-check form-check-inline">
            <input className="form-check-input" type="radio" name="radioDeclara" value="0" id="radioNo" />
            <label className="form-check-label" htmlFor="inlineRadio3">Petros</label>
        </div>

    </div> */}